var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 890 890",
    style: {
      enableBackground: "new 0 0 890 890"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00AEEF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "761,414 592.8,450.1 569.4,414 592.8,377.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "668.5,190.5 524,414 668.5,637.4 445,493 221.5,637.4 366,414 221.5,190.5 445,335  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "445,538.4 481.1,561.8 445,730 408.9,561.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "445,98 481.1,266.2 445,289.6 408.9,266.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "297.2,377.9 320.6,414 297.2,450.1 129,414  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticleLogo);
export default __webpack_public_path__ + "static/media/ParticleLogo.eb193b8f760345bdca1c383b4a3c7e92.svg";
export { ForwardRef as ReactComponent };